import { render, staticRenderFns } from "./SelectResources.vue?vue&type=template&id=7f37ce61&scoped=true"
import script from "./SelectResources.vue?vue&type=script&lang=js"
export * from "./SelectResources.vue?vue&type=script&lang=js"
import style0 from "./SelectResources.vue?vue&type=style&index=0&id=7f37ce61&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f37ce61",
  null
  
)

export default component.exports